import React from 'react';

import theme from 'utils/theme';

type SwitchIconProps = {
  width?: string;
  height?: string;
  circleColor?: string;
  iconColor?: string;
};

const SwitchIcon = ({
  width = theme.typography.large24,
  height = theme.typography.large24,
  circleColor = theme.colors.blue2[100],
  iconColor = theme.colors.white[100],
}: SwitchIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ overflow: 'visible' }}>
    <rect width="24" height="24" rx="12" fill={circleColor} />
    <path
      d="M16 7V17M16 17L13 14M16 17L19 14M8 17V7M8 7L5 10M8 7L11 10"
      stroke={iconColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default SwitchIcon;
